<div class="app-container">
  <rsc-asp-header ngSkipHydration></rsc-asp-header>
  <router-outlet></router-outlet>
  <rsc-asp-footer></rsc-asp-footer>
</div>